import React from "react";
import { Instagram, Linkedin, Facebook, Youtube, Twitter } from "lucide-react";
import { useLang } from "../lib/i18n";
import logo from "../assets/edvia-logo.png";

export function Footer({ settings }) {
  const { t } = useLang();
  const socials = settings?.socials || {};
  const siteName = settings?.siteName || "EdviaIQ";
  const items = [
    { key: "instagram", Icon: Instagram }, { key: "linkedin", Icon: Linkedin },
    { key: "facebook", Icon: Facebook }, { key: "youtube", Icon: Youtube }, { key: "twitter", Icon: Twitter },
  ].filter((s) => socials[s.key]);

  return (
    <footer className="border-t border-border bg-card" data-testid="footer">
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-4 px-4 py-10 text-center">
        <div className="flex items-center gap-2">
          <img src={logo} alt={siteName} className="h-10 w-auto object-contain" />
        </div>
        <p className="text-sm text-muted-foreground">{settings?.footerTagline || t("footer.tagline")}</p>
        {items.length > 0 && (
          <div className="flex gap-4">
            {items.map(({ key, Icon }) => (
              <a key={key} href={socials[key]} target="_blank" rel="noreferrer"
                 className="text-muted-foreground transition-colors hover:text-primary" data-testid={`social-${key}`}>
                <Icon className="h-5 w-5" />
              </a>
            ))}
          </div>
        )}
        <p className="text-xs text-muted-foreground">© {new Date().getFullYear()} {siteName}. {t("footer.rights")}</p>
      </div>
    </footer>
  );
}
